/**
 * @generated SignedSource<<457a3fc4d27df1766f7b15fe93dac0a8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RateSearchResultsPageQuery$variables = {
  searchId: number;
};
export type RateSearchResultsPageQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"ContentRateSearch_viewer" | "SideMenu_viewer">;
  } | null;
};
export type RateSearchResultsPageQuery = {
  response: RateSearchResultsPageQuery$data;
  variables: RateSearchResultsPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "searchId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "legacyId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v4 = [
  (v1/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locationId",
  "storageKey": null
},
v7 = [
  (v6/*: any*/),
  (v5/*: any*/),
  (v1/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "regionId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "searchId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdDate",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rateType",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locationFullLabel",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isGlobalSupplierSearch",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "workerTypeName",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "NewRegionNode",
  "kind": "LinkedField",
  "name": "region",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v8/*: any*/),
    (v1/*: any*/)
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jobTitle",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jobLabel",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jobTitleId",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rawMin",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rawAvg",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rawMid",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rawMax",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "iso",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "LevelType",
  "kind": "LinkedField",
  "name": "level",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "payRateMin",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "payRateMid",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "payRateMax",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billRateMin",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billRateMid",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billRateMax",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "markupPctMin",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "markupPctMid",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "markupPctMax",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "payRateAvg",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billRateAvg",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "markupPctAvg",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RateSearchResultsPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SideMenu_viewer"
          },
          {
            "args": [
              {
                "kind": "Variable",
                "name": "searchId",
                "variableName": "searchId"
              }
            ],
            "kind": "FragmentSpread",
            "name": "ContentRateSearch_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RateSearchResultsPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "resourceType",
                    "value": "SEARCH"
                  }
                ],
                "concreteType": "TrapsResourceAllocation",
                "kind": "LinkedField",
                "name": "resourceAllocations",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "balance",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isUnlimited",
                    "storageKey": null
                  }
                ],
                "storageKey": "resourceAllocations(resourceType:\"SEARCH\")"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Client",
                "kind": "LinkedField",
                "name": "client",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LegacyClientAllFieldsNode",
                    "kind": "LinkedField",
                    "name": "legacyClient",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "perSearchPricing",
                        "storageKey": null
                      },
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IndustryNodeConnection",
            "kind": "LinkedField",
            "name": "industries",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IndustryNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IndustryNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": (v4/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "countryId",
                "value": 0
              },
              {
                "kind": "Literal",
                "name": "industryId",
                "value": 0
              }
            ],
            "concreteType": "CountryWorkerType",
            "kind": "LinkedField",
            "name": "workerTypes",
            "plural": true,
            "selections": [
              {
                "alias": "workerTypeId",
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              }
            ],
            "storageKey": "workerTypes(countryId:0,industryId:0)"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "order",
                "value": [
                  {
                    "field": "NAME"
                  }
                ]
              }
            ],
            "concreteType": "NewRegionNodeConnection",
            "kind": "LinkedField",
            "name": "regions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NewRegionNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NewRegionNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LocationNode",
                        "kind": "LinkedField",
                        "name": "country",
                        "plural": false,
                        "selections": (v7/*: any*/),
                        "storageKey": null
                      },
                      (v5/*: any*/),
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LocationNode",
                        "kind": "LinkedField",
                        "name": "locations",
                        "plural": true,
                        "selections": [
                          (v6/*: any*/),
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LocationNode",
                            "kind": "LinkedField",
                            "name": "parent",
                            "plural": false,
                            "selections": (v7/*: any*/),
                            "storageKey": null
                          },
                          (v1/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "regions(order:[{\"field\":\"NAME\"}])"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CountryListNode",
            "kind": "LinkedField",
            "name": "countries",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isoCode",
                "storageKey": null
              },
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "recentSearches",
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 9
              },
              {
                "kind": "Literal",
                "name": "order",
                "value": [
                  {
                    "direction": "DESC",
                    "field": "CREATE_DATE"
                  }
                ]
              }
            ],
            "concreteType": "SaveSearchNodeConnection",
            "kind": "LinkedField",
            "name": "savedsearches",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SaveSearchNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SaveSearchNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v5/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "IndustryNode",
                        "kind": "LinkedField",
                        "name": "industry",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "JobResponse",
                        "kind": "LinkedField",
                        "name": "job",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v18/*: any*/),
                          (v1/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "savedsearches(first:9,order:[{\"direction\":\"DESC\",\"field\":\"CREATE_DATE\"}])"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "searchId"
              }
            ],
            "concreteType": "SaveSearchNode",
            "kind": "LinkedField",
            "name": "savedsearch",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v9/*: any*/),
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "JobResponse",
                "kind": "LinkedField",
                "name": "job",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v18/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "collectionId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jobDescription",
                "storageKey": null
              },
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "IndustryNode",
                "kind": "LinkedField",
                "name": "industry",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NewRegionNode",
                "kind": "LinkedField",
                "name": "region",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v5/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "workerTypeId",
                "storageKey": null
              },
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RateCardNode",
                "kind": "LinkedField",
                "name": "rateCard",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v5/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RateSearchResponse",
                "kind": "LinkedField",
                "name": "rates",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "rawBillRates",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "perDiem",
                    "storageKey": null
                  },
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/)
                ],
                "storageKey": null
              },
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CurrencyNode",
                "kind": "LinkedField",
                "name": "currency",
                "plural": false,
                "selections": [
                  (v23/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MarketRatesNode",
                "kind": "LinkedField",
                "name": "marketrates",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/),
                  (v30/*: any*/),
                  (v31/*: any*/),
                  (v32/*: any*/),
                  (v33/*: any*/),
                  (v34/*: any*/),
                  (v35/*: any*/),
                  (v36/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "ids",
                "value": []
              }
            ],
            "concreteType": "LocationListLookupNode",
            "kind": "LinkedField",
            "name": "locationsByIds",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lat",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lon",
                "storageKey": null
              }
            ],
            "storageKey": "locationsByIds(ids:[])"
          },
          {
            "alias": null,
            "args": [
              {
                "fields": [
                  {
                    "kind": "Literal",
                    "name": "only",
                    "value": []
                  }
                ],
                "kind": "ObjectValue",
                "name": "filters"
              }
            ],
            "concreteType": "SaveSearchNodeConnection",
            "kind": "LinkedField",
            "name": "savedsearches",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SaveSearchNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SaveSearchNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v6/*: any*/),
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "country",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "locationLabel",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CurrencyNode",
                        "kind": "LinkedField",
                        "name": "currency",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v23/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RateSearchResponse",
                        "kind": "LinkedField",
                        "name": "rates",
                        "plural": false,
                        "selections": [
                          (v19/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MarketRatesNode",
                        "kind": "LinkedField",
                        "name": "marketrates",
                        "plural": true,
                        "selections": [
                          (v1/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/),
                          (v26/*: any*/),
                          (v27/*: any*/),
                          (v34/*: any*/),
                          (v28/*: any*/),
                          (v29/*: any*/),
                          (v30/*: any*/),
                          (v35/*: any*/),
                          (v31/*: any*/),
                          (v32/*: any*/),
                          (v33/*: any*/),
                          (v36/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "savedsearches(filters:{\"only\":[]})"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ec2c45c10a47eac1f057f803246ef6d6",
    "id": null,
    "metadata": {},
    "name": "RateSearchResultsPageQuery",
    "operationKind": "query",
    "text": "query RateSearchResultsPageQuery(\n  $searchId: Int!\n) {\n  viewer {\n    ...SideMenu_viewer\n    ...ContentRateSearch_viewer_1CYBKI\n  }\n}\n\nfragment BellCurveBillRates_savedsearch on SaveSearchNode {\n  id\n  currency {\n    id\n    iso\n  }\n  rates {\n    rawBillRates\n    perDiem\n    rawMin\n    rawAvg\n    rawMid\n    rawMax\n  }\n}\n\nfragment ContentRateSearch_viewer_1CYBKI on Viewer {\n  ...JobTitleSearchResults_savesearch_1CYBKI\n  ...ResultOptions_viewer_1CYBKI\n  ...SettingsMenuSearchResutls_viewer_1CYBKI\n  ...ResultTabs_viewer_1CYBKI\n}\n\nfragment CurrencyDropdown_viewer on Viewer {\n  countries {\n    name\n    isoCode\n    id\n  }\n}\n\nfragment DetailCards_savedsearch on SaveSearchNode {\n  id\n  rateType\n  currency {\n    id\n    iso\n  }\n  marketrates {\n    id\n    level {\n      value\n    }\n    payRateMin\n    payRateMid\n    payRateMax\n    payRateAvg\n    billRateMin\n    billRateMid\n    billRateMax\n    billRateAvg\n    markupPctMin\n    markupPctMid\n    markupPctMax\n    markupPctAvg\n  }\n}\n\nfragment DetailTable_savedsearch on SaveSearchNode {\n  id\n  rateType\n  currency {\n    id\n    iso\n  }\n  marketrates {\n    id\n    level {\n      value\n    }\n    payRateMin\n    payRateMid\n    payRateMax\n    payRateAvg\n    billRateMin\n    billRateMid\n    billRateMax\n    billRateAvg\n    markupPctMin\n    markupPctMid\n    markupPctMax\n    markupPctAvg\n  }\n}\n\nfragment FormRateSearch_viewer on Viewer {\n  user {\n    ...HeadingForm_user\n    ...SubmitRateSearch_user\n  }\n  ...IndustriesField_viewer\n  ...WorkerTypeField_viewer\n  ...RegionsField_viewer\n  ...SupportedCountries_viewer\n}\n\nfragment HeadingForm_user on User {\n  resourceAllocations(resourceType: SEARCH) {\n    id\n    balance\n    isUnlimited\n  }\n}\n\nfragment IndustriesField_viewer on Viewer {\n  industries {\n    edges {\n      node {\n        id\n        legacyId\n        value\n      }\n    }\n  }\n}\n\nfragment JobTitleSearchResults_savesearch_1CYBKI on Viewer {\n  savedsearch(id: $searchId) {\n    id\n    searchId\n    isGlobalSupplierSearch\n    job {\n      id\n      jobTitleId\n      jobTitle\n      jobLabel\n      collectionId\n    }\n    jobDescription\n    locationFullLabel\n    industry {\n      id\n      legacyId\n      value\n    }\n    region {\n      regionId\n      name\n      id\n    }\n    rateType\n    workerTypeId\n    workerTypeName\n    rateCard {\n      legacyId\n      name\n      id\n    }\n  }\n}\n\nfragment MedianPayChart_savedsearch on SaveSearchNode {\n  id\n  rateType\n  currency {\n    id\n    iso\n  }\n  marketrates {\n    id\n    level {\n      legacyId\n      value\n    }\n    payRateMin\n    payRateMid\n    payRateMax\n    billRateMin\n    billRateMid\n    billRateMax\n    markupPctMin\n    markupPctMid\n    markupPctMax\n  }\n}\n\nfragment ModifyLocationsDialog_viewer on Viewer {\n  user {\n    resourceAllocations(resourceType: SEARCH) {\n      id\n      balance\n      isUnlimited\n    }\n  }\n  ...RegionsField_viewer\n}\n\nfragment PayDifferenceMap_viewer on Viewer {\n  locationsByIds(ids: []) {\n    locationId\n    lat\n    lon\n  }\n}\n\nfragment PayDifference_viewer on Viewer {\n  ...ModifyLocationsDialog_viewer\n  ...PayDifferenceMap_viewer\n  countries {\n    id\n    locationId\n    isoCode\n    name\n  }\n  savedsearches(filters: {only: []}) {\n    edges {\n      node {\n        searchId\n        locationId\n        locationFullLabel\n        country\n        locationLabel\n        currency {\n          id\n          iso\n        }\n        region {\n          name\n          regionId\n          id\n        }\n        rates {\n          rawMin\n          rawAvg\n          rawMid\n          rawMax\n        }\n        marketrates {\n          id\n          level {\n            legacyId\n            value\n          }\n          payRateMin\n          payRateMid\n          payRateMax\n          payRateAvg\n          billRateMin\n          billRateMid\n          billRateMax\n          billRateAvg\n          markupPctMin\n          markupPctMid\n          markupPctMax\n          markupPctAvg\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment RateDetail_savedsearch on SaveSearchNode {\n  id\n  rateType\n  ...DetailTable_savedsearch\n  ...DetailCards_savedsearch\n}\n\nfragment RecentSearches_viewer on Viewer {\n  recentSearches: savedsearches(first: 9, order: [{field: CREATE_DATE, direction: DESC}]) {\n    edges {\n      node {\n        id\n        searchId\n        createdDate\n        name\n        rateType\n        locationFullLabel\n        isGlobalSupplierSearch\n        workerTypeName\n        industry {\n          id\n          value\n        }\n        region {\n          name\n          regionId\n          id\n        }\n        job {\n          jobTitle\n          jobLabel\n          jobTitleId\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment RegionsField_viewer on Viewer {\n  regions(order: [{field: NAME}]) {\n    edges {\n      node {\n        country {\n          locationId\n          name\n          id\n        }\n        name\n        regionId\n        locations {\n          locationId\n          name\n          parent {\n            locationId\n            name\n            id\n          }\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment ResultOptions_viewer_1CYBKI on Viewer {\n  savedsearch(id: $searchId) {\n    id\n    rates {\n      rawBillRates\n    }\n    rateCard {\n      id\n      legacyId\n      name\n    }\n  }\n}\n\nfragment ResultTabs_viewer_1CYBKI on Viewer {\n  ...PayDifference_viewer\n  countries {\n    id\n    locationId\n    isoCode\n    name\n  }\n  savedsearch(id: $searchId) {\n    id\n    rateType\n    workerTypeId\n    workerTypeName\n    createdDate\n    currency {\n      iso\n      id\n    }\n    region {\n      regionId\n      id\n    }\n    job {\n      jobTitleId\n      jobTitle\n      id\n    }\n    locationId\n    industry {\n      id\n      legacyId\n      value\n    }\n    ...MedianPayChart_savedsearch\n    ...RateDetail_savedsearch\n    ...BellCurveBillRates_savedsearch\n  }\n}\n\nfragment SettingsMenuSearchResutls_viewer_1CYBKI on Viewer {\n  ...CurrencyDropdown_viewer\n  savedsearch(id: $searchId) {\n    id\n    rateType\n  }\n}\n\nfragment SideMenu_viewer on Viewer {\n  ...FormRateSearch_viewer\n  ...RecentSearches_viewer\n}\n\nfragment SubmitRateSearch_user on User {\n  client {\n    legacyClient {\n      perSearchPricing\n      id\n    }\n    id\n  }\n  resourceAllocations(resourceType: SEARCH) {\n    id\n    balance\n    isUnlimited\n  }\n}\n\nfragment SupportedCountries_viewer on Viewer {\n  countries {\n    id\n    isoCode\n    name\n    locationId\n  }\n}\n\nfragment WorkerTypeField_viewer on Viewer {\n  workerTypes(countryId: 0, industryId: 0) {\n    workerTypeId: id\n    name\n    description\n  }\n}\n"
  }
};
})();

(node as any).hash = "06485d6c773a54e0704434a910be4dd0";

export default node;
